<section class="custom-route__action-buttons">
  <div class="actions-buttons__edit-button-container">
      <ci-button
        class="actions-buttons__button"
        class-name="ci-btn-primary-s-outlined"
        [arial-label]="'Cancelar edición' | translate"
        (click)="handleCancelEditClick()"
      >
        {{ 'Cancelar' | translate }}
      </ci-button>
      
      <ci-button
        class="actions-buttons__button"
        class-name="ci-btn-primary-s-filled"
        [attr.arial-label]="'Guardar edición' | translate"
        [disabled]="disabledButton ? true : false"
        (click)="handleUpdateEditClick()"
      >
        {{ 'Actualizar' | translate }}
      </ci-button>
  </div>
</section>